import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// LOGOS
import dialAmericaLogo from "../../../assets/EMP_CallAndContact/EMP_RealStoriesSection/dial-america.webp";
import inceptLogo from "../../../assets/EMP_CallAndContact/EMP_RealStoriesSection/dial-america.webp";

const EMP_RealStoriesSection = () => {

  const testimonials = [
    {
      logo: dialAmericaLogo,

      text: `“The longer we keep our employees, the more confident they become in their skills. That confidence leads to better interactions with our clients’ customers. DailyPay keeps our agents here longer, increasing their skill set and improving customer experience.”`,

      name: "Rob Schultz",

      role: "Senior VP, Human Resources & Compliance",
    },

    {
      logo: dialAmericaLogo,

      text: `“We promote DailyPay to all of our new hires and have seen great results and a lot of excitement in that particular sector. Prior to DailyPay, a new hire would have to wait a total of two weeks prior to receiving their first paycheck.”`,

      name: "Mike Beaubrun",

      role: "Operations Manager, DialAmerica",

      button: "Download our guide",
    },

    {
      logo: inceptLogo,

      text: `“[DailyPay] was rewarding to me. It made me feel more independent and more grateful for the work that I did every day, knowing that I’d see an immediate result. It was a nice feeling.”`,

      name: "Jodi N",

      role: "Incept Results Employee",
    },
  ];

  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <section className="w-full bg-[#f3f3f3] overflow-hidden">

      <div
        className="
          max-w-[1400px]
          mx-auto

          px-5
          sm:px-8
          lg:px-16

          py-16
          sm:py-20
          lg:py-[100px]
        "
      >

        {/* HEADING */}

        <h2
          className="
            text-center
            text-[#2b0000]

            font-serif
            font-normal

            leading-[1]

            text-[42px]
            sm:text-[56px]
            md:text-[70px]
            lg:text-[48px]

            max-w-[1000px]
            mx-auto
          "
        >
          Real Results. Real Stories.
        </h2>

        {/* TOP BORDER */}

        <div className="border-t border-[#cfcfcf] mt-10 sm:mt-14 lg:mt-[30px] lg:max-w-[800px]  mx-auto"></div>

        {/* SLIDER */}

        <div
          className="
            relative

            flex
            items-center
            justify-center

            mt-12
            sm:mt-16
          "
        >

          {/* LEFT BUTTON */}

          <button
            onClick={prevSlide}
            className="
              hidden
              lg:flex

              absolute
              left-0
              lg:ml-[200px]

              items-center
              justify-center

              w-[54px]
              h-[54px]

              rounded-full

              bg-white

              shadow-md

              text-[#2b0000]

              hover:scale-105
              transition-all
            "
          >
            <ChevronLeft size={32} />
          </button>

          {/* CONTENT */}

          <div
            className="
              text-center

              max-w-[950px]
              mx-auto
              lg:-mt-[40px]
            "
          >

            {/* LOGO */}

            <img
              src={testimonials[current].logo}
              alt="Company Logo"
              className="
                mx-auto

                h-[55px]
                sm:h-[70px]
                lg:h-[40px]

                object-contain
              "
            />

            {/* TEXT */}

            <p
              className="
                mt-8
                lg:mt-4

                text-[#1d1111]

                font-sans
                font-bold

                leading-[1.5]

                text-[24px]
                sm:text-[30px]
                md:text-[38px]
                lg:text-[22px]
                lg:max-w-[700px]
              "
            >
              {testimonials[current].text}
            </p>

            {/* NAME */}

            <h3
              className="
                mt-8
                lg:mt-4

                text-[#1f2937]

                font-sans
                font-bold

                text-[18px]
                sm:text-[26px]
                lg:text-[18px]
              "
            >
              {testimonials[current].name}
            </h3>

            {/* ROLE */}

            <p
              className="
                mt-3
                lg:mt-2

                text-[#6b7280]

                font-sans
                font-normal

                text-[20px]
                sm:text-[20px]
                lg:text-[16px]
              "
            >
              {testimonials[current].role}
            </p>

            {/* OPTIONAL BUTTON */}

            {testimonials[current].button && (
              <button
                className="
                  mt-10

                  text-[#1d1111]

                  font-sans
                  font-semibold

                  text-[22px]
                  sm:text-[24px]
                  lg:text-[18px]

                  hover:underline
                "
              >
                {testimonials[current].button}
              </button>
            )}
          </div>

          {/* RIGHT BUTTON */}

          <button
            onClick={nextSlide}
            className="
              hidden
              lg:flex

              absolute
              right-0
              lg:mr-[200px]

              items-center
              justify-center

              w-[54px]
              h-[54px]

              rounded-full

              bg-white

              shadow-md

              text-[#2b0000]

              hover:scale-105
              transition-all
            "
          >
            <ChevronRight size={32} />
          </button>
        </div>

        {/* BOTTOM BORDER */}

        <div className="border-t border-[#cfcfcf] mt-12 lg:mt-6 lg:max-w-[800px] mx-auto"></div>

        {/* DOTS */}

        <div
          className="
            flex
            items-center
            justify-center

            gap-4

            mt-8
            lg:mt-6
          "
        >
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`
                w-[12px]
                h-[12px]
                rounded-full
                transition-all

                ${
                  current === index
                    ? "bg-[#2b0000]"
                    : "bg-[#8d95a5]"
                }
              `}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default EMP_RealStoriesSection;